import React from "react";
export default function Icon(props) {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00005 0.600098V3.0001C8.00005 3.44193 8.35823 3.8001 8.80005 3.8001H11.2001M3.60005 3.8001H5.20005M3.60005 6.2001H8.40006M3.60005 8.6001H8.40006M10.0001 1.8001C9.644 1.48153 9.27453 1.10368 9.04129 0.858283C8.88608 0.694987 8.67163 0.600098 8.44634 0.600098H2.39987C1.51621 0.600098 0.799872 1.31644 0.799867 2.20009L0.799805 11.8001C0.799799 12.6837 1.51614 13.4001 2.3998 13.4001L9.59983 13.4001C10.4835 13.4001 11.1998 12.6838 11.1998 11.8001L11.2 3.31865C11.2001 3.11409 11.122 2.91745 10.98 2.77019C10.7175 2.49786 10.2791 2.04978 10.0001 1.8001Z"
        stroke="#13816F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
